/*
* BC 2019/02 - Les tables "simuexo" sont des tables facultatives
* elles reprennent les tables "exo" du même nom et servent à la collecte et à la sauvegarde d'informations en mode EPURE et EXAMEN
* dans ces 2 modes et lors du passage à l'étape SIMULATION, elles permettront l'alimentation des tables "exo"
* NB : le mode de collecte des infos en back (auteur) et en front (eleve) etant different la structure des tables sera egalement différente
* il faut donc prévoir un "réagencement" des données à cette étape
*/
import lf from 'lovefield'

export function simuexo_chantiers (schemaBuilder) {
  schemaBuilder.createTable('simuexo_chantiers')
      .addColumn('id', lf.Type.INTEGER)
      .addColumn('code', lf.Type.STRING)
      .addColumn('nom', lf.Type.STRING)
      .addColumn('kmdebut')
      .addColumn('longueur')
      .addColumn('const_humidite_id')
      .addColumn('efficience')
      .addColumn('debut')
      .addColumn('delai')
      .addColumn('budget')
      .addColumn('vitessemax')
      .addColumn('stopautomatiqsimu_1')
      .addColumn('stopautomatiqsimu_2')
      .addColumn('description')
      .addColumn('alea_group_id', lf.Type.INTEGER)
      .addNullable(['alea_group_id'])
      .addPrimaryKey(['id'])
}
/*
id	-1
code	EPUR
nom 		saisie libre (taille ?)
exo_chantiers_groupe_id 	0
kmdebut 		en mètre
longueur 		en mètre
const_humidite_id		combo
efficience 		En %
debut 		date
delai 		en jours ouvrés (demander la date de fin)
budget 		en Euros
vitessemax 		30 < < 100
stopautomatiqsimu_1 	0
stopautomatiqsimu_2 	0
description 		vide
valid 	1
is_publiable 	1
created 	NULL
modified 	NULL
created_by 	NULL
modified_by 	NULL
*/



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/simuexoChantiers.schema.js